import React, { useCallback, useState, useMemo } from 'react';

//devExtrem
import SelectBox, { } from 'devextreme-react/select-box';

//modele
import IEditorOptions from '../models/IEditorOptions';
import ICustomSelectBoxData from '../models/ICostumSelectBoxData';

//constantes
import { SECTION_NAME, VENTILATION, TARIFICATION } from '../pages/gestion-plans/calendrier/constant';
import { hooksEnum } from '../types';
import { GIBIER_TYPES, GIBIER, ESPECES, GROS_GIBIER } from '../pages/gestion-gibiers/enum';
import { MODE_CALCUL_TYPE_SEJOUR } from '../pages/gestion-types-sejours/enum';
import { TYPE_CAMPING, TYPE_ROULOTTE } from '../pages/gestion-roulottes/enum';
import { TYPE_ETAT_CACHE, TYPE_STATUT_CACHE } from '../pages/gestion-caches/gestion-caches-type-enum';
import { SPECIAUX_ELIGIBILITE, SPECIAUX_TYPE } from '../pages/gestion-catalogue-produits/enum';
import { TYPES_ACTIVITE } from '../pages/gestion-activites/enums';
import { TYPE_COMPTE } from '../pages/gestion-folios/enum';
import { TYPES_SERVICES, TYPE_AMPERAGES } from '../pages/gestion-types-services/enum';
import { STATUT_RESIDENT, STATUT_MEMBRE } from '../pages/gestion-plans/calendrier/constant';
import { DUREES, ORDRE_TRI } from '../pages/gestion-groupes-types-unites/enum';
import { TYPE_ENTREPRISE } from '../pages/gestion-entreprises/enum';
import { MODE_PAIEMENT } from '../pages/gestion-types-paiements/enum';
import { MESSAGE_POSITION_PAGE, MESSAGE_POSITION_NUMERO_PAGE, MESSAGE_TYPE } from '../pages/gestion-messages/enum';
import { TYPES_HEBERGEMENT, ENSOLEILLEMENT } from '../pages/gestion-unites/enum';
import { ETATS_EVENEMENT } from '../pages/gestion-evenements/enum';

const useEnum = (section: 'ventilation' | 'tarifiaction' = 'ventilation', typeEnum?: hooksEnum, width: string = '100%', maxLength: number = 10) => {
  const gestionPlanModeCalCul: ICustomSelectBoxData[] = section === SECTION_NAME.ventilation ? VENTILATION : TARIFICATION;
  const gestionGibierTypes: ICustomSelectBoxData[] = GIBIER_TYPES;
  const gestionGibierTypePetitGibier: ICustomSelectBoxData[] = GIBIER;
  const gestionGibierTypeGrosGibier: ICustomSelectBoxData[] = GROS_GIBIER;
  const gestionEspeces: ICustomSelectBoxData[] = ESPECES;
  const gestionTypeSejourMOdeCalcul: ICustomSelectBoxData[] = MODE_CALCUL_TYPE_SEJOUR;
  const gestionRoulottesTypeRoulotte: ICustomSelectBoxData[] = TYPE_ROULOTTE;
  const gestionRoulottesTypeCamping: ICustomSelectBoxData[] = TYPE_CAMPING;
  const gestionCacheEtatCache: ICustomSelectBoxData[] = TYPE_ETAT_CACHE;
  const gestionCacheStatutCache: ICustomSelectBoxData[] = TYPE_STATUT_CACHE;
  const gestionCatalogueProduitsSpeciauxEligibilite: ICustomSelectBoxData[] = SPECIAUX_ELIGIBILITE;
  const gestionCatalogueProduitsSpeciauxType: ICustomSelectBoxData[] = SPECIAUX_TYPE;
  const gestionTypesActivite: ICustomSelectBoxData[] = TYPES_ACTIVITE;
  const gestionFolioTypeCompte: ICustomSelectBoxData[] = TYPE_COMPTE;
  const gestionTypesServices: ICustomSelectBoxData[] = TYPES_SERVICES;
  const gestionTypesAmperages: ICustomSelectBoxData[] = TYPE_AMPERAGES;
  const gestionPlansModeCalcul: ICustomSelectBoxData[] = TARIFICATION;
  const gestionStatutResident: ICustomSelectBoxData[] = STATUT_RESIDENT;
  const gestionStatutMembre: ICustomSelectBoxData[] = STATUT_MEMBRE;
  const gestionDurees: ICustomSelectBoxData[] = DUREES;
  const gestionOrdreTri: ICustomSelectBoxData[] = ORDRE_TRI;
  const gestionTypeEntreprise: ICustomSelectBoxData[] = TYPE_ENTREPRISE;
  const gestionModePaiement: ICustomSelectBoxData[] = MODE_PAIEMENT;
  const gestionMessagePositionPage: ICustomSelectBoxData[] = MESSAGE_POSITION_PAGE;
  const gestionMessagePositionNumeroPage: ICustomSelectBoxData[] = MESSAGE_POSITION_NUMERO_PAGE;
  const gestionMessageType: ICustomSelectBoxData[] = MESSAGE_TYPE;
  const gestionTypesHebergement: ICustomSelectBoxData[] = TYPES_HEBERGEMENT;
  const gestionTypesEnsoleillement: ICustomSelectBoxData[] = ENSOLEILLEMENT;
  const gestionEvenementsEtat: ICustomSelectBoxData[] = ETATS_EVENEMENT;
  const [currentSelectedItem, setCurrentSelectedItem] = useState<ICustomSelectBoxData>();

  const editorOptions = useMemo((): IEditorOptions<ICustomSelectBoxData[]> => {
    let dataSource: ICustomSelectBoxData[] = [];

    switch (typeEnum) {
      case 'gestionPlanModeCalCul':
        dataSource = gestionPlanModeCalCul;
        break;
      case 'gestionGibierTypes':
        dataSource = gestionGibierTypes;
        break;
      case 'gestionGibierTypePetitGibier':
        dataSource = gestionGibierTypePetitGibier;
        break;
      case 'gestionGibierTypeGrosGibier':
        dataSource = gestionGibierTypeGrosGibier;
        break;
      case 'gestionEspeces':
        dataSource = gestionEspeces
        break;
      case 'gestionTypeSejourMOdeCalcul':
        dataSource = gestionTypeSejourMOdeCalcul
        break;
      case 'gestionRoulottesTypeRoulotte':
        dataSource = gestionRoulottesTypeRoulotte
        break;
      case 'gestionRoulottesTypeCamping':
        dataSource = gestionRoulottesTypeCamping
        break;
      case 'gestionCacheEtatCache':
        dataSource = gestionCacheEtatCache
        break;
      case 'gestionCacheStatutCache':
        dataSource = gestionCacheStatutCache
        break;
      case 'gestionCatalogueProduitsSpeciauxEligibilite':
        dataSource = gestionCatalogueProduitsSpeciauxEligibilite
        break;
      case 'gestionCatalogueProduitsSpeciauxType':
        dataSource = gestionCatalogueProduitsSpeciauxType
        break;
      case 'gestionTypesActivite':
        dataSource = gestionTypesActivite;
        break;
      case 'gestionFolioTypeCompte':
        dataSource = gestionFolioTypeCompte;
        break;
      case 'gestionTypesServices':
        dataSource = gestionTypesServices;
        break;
      case 'gestionTypesAmperages':
        dataSource = gestionTypesAmperages;
        break;
      case 'gestionPlansModeCalcul':
        dataSource = gestionPlansModeCalcul;
        break;
      case 'gestionStatutResident':
        dataSource = gestionStatutResident;
        break;
      case 'gestionStatutMembre':
        dataSource = gestionStatutMembre;
        break;
      case 'gestionDurees':
        dataSource = gestionDurees;
        break;
      case 'gestionOrdreTri':
        dataSource = gestionOrdreTri;
        break;
      case 'gestionTypeEntreprise':
        dataSource = gestionTypeEntreprise;
        break;
      case 'gestionModePaiement':
        dataSource = gestionModePaiement;
        break;
      case 'gestionMessagePositionPage':
        dataSource = gestionMessagePositionPage;
        break;
      case 'gestionMessagePositionNumeroPage':
        dataSource = gestionMessagePositionNumeroPage;
        break;
      case 'gestionMessageType':
        dataSource = gestionMessageType;
        break;
      case 'gestionTypesHebergement':
        dataSource = gestionTypesHebergement;
        break;
      case 'gestionTypesEnsoleillement':
        dataSource = gestionTypesEnsoleillement;
        break;
      case 'gestionEvenementsEtat':
        dataSource = gestionEvenementsEtat;
        break;
      default:
        break;
    }
    return {
      searchEnabled: true,
      dataSource: dataSource,
      displayExpr: "description",
      displayValue: "id",
      valueExpr: "id",
      width: width,
      maxLength: maxLength,
    }
  }, [gestionPlanModeCalCul])

  const EnumSelectBox = useCallback((params: any) => {
    const { dataField, component, column, data } = params
    const formOptions = component.option();
    const value = dataField ? formOptions.formData[dataField] : data[column.dataField]

    const onValueChange = (args: any) => {
      component.updateData(dataField, args.value)
    }

    const onSelectionChanged = (e: any) => {
      setCurrentSelectedItem(e.selectedItem)
    }

    return (
      <SelectBox
        value={value}
        onValueChange={onValueChange}
        readOnly={formOptions.readOnly}
        valueExpr={editorOptions.valueExpr}
        dataSource={editorOptions.dataSource}
        displayExpr={editorOptions.displayExpr}
        onSelectionChanged={onSelectionChanged}
        displayValue={editorOptions.displayValue}
        maxLength={editorOptions.maxLength}
      />
    )
  }, [editorOptions, currentSelectedItem])

  return {
    editorOptions,
    EnumSelectBox
  }

}

export default useEnum;